export { default } from './general-info';
